// src/api/user.ts
import ApiService from "@/utils/request";
/**
 * 用户模块 API 集合
 * 所有用户相关请求统一在此管理，便于维护和复用
 */
export const loginApi = {
    /**
     * 用户登录
     * @param params 登录参数（用户名+密码）
     * @returns Token + 用户信息
     */
    login: (params) => ApiService.post("/auth/login", params),
};
